.bq{max-width:100%;}